<div class="dx-field">
  <div class="dx-field-label" style='width: 170px;'>Electronic Signature</div>
  <div class="dx-field-value">
    <dx-radio-group
      [items]="signature"
      [(value)]="selected"
      (onValueChanged)="valueChanged()"
      [layout]="'horizontal'">
    </dx-radio-group>
  </div>
</div>

